module.exports = __webpack_public_path__ + "static/media/college.db1d6822.png";